import "./LinksTab.scss";

import React from "react";
import { connect } from "react-redux";

import Workstreams from "./Workstreams/Workstreams";
import Select from "Components/common/Select/Select";
import Search from "./Search/Search";
@connect(store => {
    return {
        conversations: store.conversations,
        loggedUser: store.loggedUser
    }
})

class LinksTab extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { conversations, loggedUser, isAdmin } = this.props;
        
        if( conversations.selected.id ) {
            const selected = conversations.selected;
            const project  = selected.project;
            const isAdminNotMember = loggedUser.data.userRole < 3 && conversations.selected.tagged_users.filter( u => u.linkId === loggedUser.data.id ).length === 0;
            const isMember = conversations.selected.tagged_users.filter(t=>t.linkId === loggedUser.data.id);

            return (
                <div class="detailsWrapper">
                    <div class="detailsNote">
                        { isAdmin && !isAdminNotMember && !selected.isArchived && isMember.length > 0 ? 
                            ( <p>This conversation is linked to:</p> )
                            :
                            ( <p>This conversation is tagged to the following Workstreams in { project.project }</p> )
                        }
                    </div>

                    { isAdmin && !isAdminNotMember && !selected.isArchived && isMember.length > 0 &&
                        <Search />
                    }

                    <div class="workstreamLinkContainer">
                        <Workstreams isAdmin={ isAdmin } isAdminNotMember={isAdminNotMember}/>
                    </div>
                </div>
            );
        }

        return null;
    }
}

export default LinksTab;